<template>
	<div class="all-wizard">
		<div class="container-wizards">
			<h2 class="title-wizards" v-if="!estimator">Yes, your project requires Title 24 Compliance</h2>
			<h2 class="title-wizards" v-if="estimator">Select the correct cost estimator</h2>
			<div class="sub-type">
				<div class="label" >
					<div>Type of work to be performed:</div>
				</div>

				<b-form-group label="">
					<b-form-radio-group id="radios2" v-model="selectedSecondRadiosGroup" name="radioSubComponentType">

						<b-form-radio value="conversionOnly"><span>Conversion only</span></b-form-radio>
						<b-form-radio value="conversionPlusAdditions" ><span>Conversion Plus-Addition</span></b-form-radio>
					</b-form-radio-group>
				</b-form-group>

				<!-- <div class="options-wizards">
					<a @click="setSecondState('newBuilding', 1)" class="first-a" :class="{'is-active': activeTypeA === 1}" ><span>New Building</span></a> <a @click="setSecondState('existingPlusAdditions', 2)" :class="{'is-active': activeTypeA === 2}" ><span>Existing-Plus-Addition</span></a><a @click="setSecondState('newPlusAdditions', 3)"  :class="{'is-active': activeTypeA === 3}" ><span>Addition as New Building</span></a>
				</div> -->
				</div>

				<transition name="fade" mode="out-in">
					<newBuildingComponent newDwelling='none' v-if='whereAreWeSecond("conversionOnly")' />
					<conversion-plus-additions wichComponent='existing' v-if='whereAreWeSecond("conversionPlusAdditions")' />
					<!-- <generic-residential-component wich="new" v-if='selectedSecondRadiosGroup === "conversionOnly"' /> -->
				</transition>

		</div>
	</div>
</template>

<script>
import eventBus from '@/commonSite/eventBus.js'
// import genericResidentialComponent from '@/components/complianceWizard/residentialWizards/genericResidentialComponents.vue'
import newBuildingComponent from './newBuildings.vue'
// import conversionOnly from './conversionOnly.vue'
import conversionPlusAdditions from './conversionOrExistingPlusAdditions.vue'
import LocalStorageService from '@/commonSite/StorageService.js'
export default {
	name: 'all-wizards',
	props: ['estimator'],
	data: function () {
		return {
			navLinks: {},
			selectedSecondRadiosGroup: '',
			activeTypeA: 1
		}
	},
	components: {
		// conversionOnly,
		conversionPlusAdditions,
		newBuildingComponent
		// genericResidentialComponent
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
	},
	created () {
		this.getAccordionsValue()
		eventBus.$on('value-accordion-a', () => {
			// console.debug('father has speaked: and say a is closed ')
			this.selectedSecondRadiosGroup = ''
		})
	},
	methods: {
		setSecondState: function (tipo, cssWho) {
			this.selectedSecondRadiosGroup = tipo
			this.activeTypeA = cssWho
		},
		whereAreWeSecond: function (value) {
			// This method detect if select correct option return true
			if (this.selectedSecondRadiosGroup === value) {
				return true
			}
			this.setAccordionState()
		},
		getAccordionsValue () {
			let localStorage = new LocalStorageService()
			this.selectedSecondRadiosGroup = localStorage.findItem('subMenuResidential', true)
		},
		setAccordionState () {
			let localStorage = new LocalStorageService()
			localStorage.setItem('subMenuResidential', this.selectedSecondRadiosGroup, true)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/complianceWizard/residentialWizards/menuResidentialVaration.vue